import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["updatedAt", "createdAt", "internalUpdatedAt"];
import { isEqual, isEmpty, isObject, isFunction, last } from 'underscore';
import { PostSubmissionOptions } from 'asset-actions-lib-forms/constants/form';
/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/utils/FormSavingUtils.tsx#L240
 */
export const validateFormByPostSubmissionOption = ({
  formDefinition,
  postSubmissionOption
}) => {
  const isThankYouInvalid = isEqual(postSubmissionOption, PostSubmissionOptions.THANK_YOU_MESSAGE) && (isEmpty(formDefinition.inlineMessage) || isEqual(formDefinition.inlineMessage, '<p></p>'));
  const isRedirectPageInvalid = isEqual(postSubmissionOption, PostSubmissionOptions.REDIRECT_PAGE) && isEmpty(formDefinition.redirect);
  if (isThankYouInvalid) {
    return {
      valid: false,
      type: PostSubmissionOptions.THANK_YOU_MESSAGE
    };
  } else if (isRedirectPageInvalid) {
    return {
      valid: false,
      type: PostSubmissionOptions.THANK_YOU_MESSAGE
    };
  } else {
    return {
      valid: true,
      type: null
    };
  }
};

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/utils/FormSavingUtils.tsx#L123
 */
export const getFormattedDefinition = (postSubmissionOption = '', formDefinition = {}, recipients = []) => {
  let formattedFormDefinition = Object.assign({}, formDefinition);
  if (isEqual(postSubmissionOption, PostSubmissionOptions.THANK_YOU_MESSAGE)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      redirect: ''
    });
  } else if (isEqual(postSubmissionOption, PostSubmissionOptions.REDIRECT_PAGE)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      inlineMessage: ''
    });
  }
  if (isEmpty(last(recipients))) {
    // Remove empty input from list
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      notifyRecipients: recipients.slice(0, recipients.length - 1).join(',')
    });
  }

  // Add meta data if empty
  if (isEmpty(formattedFormDefinition.metaData)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      metaData: []
    });
  }

  // Stringify Style
  if (!isEmpty(formattedFormDefinition.style) && isFunction(formattedFormDefinition.style.toJS)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      style: JSON.stringify(formattedFormDefinition.style.toJS())
    });
  }

  // Stringify metaData values
  const formattedMetaData = formattedFormDefinition.metaData.map(({
    name,
    value
  }) => {
    let formattedValue = value;
    if (isObject(formattedValue)) {
      formattedValue = JSON.stringify(formattedValue);
    }
    return {
      name,
      value: formattedValue
    };
  });
  formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
    metaData: formattedMetaData
  });
  return formattedFormDefinition;
};

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/api/FormDrafts.js#L14
 */
export const convertDatesBackToTimestamps = _ref => {
  let {
      updatedAt,
      createdAt,
      internalUpdatedAt
    } = _ref,
    formDefinition = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, formDefinition, {
    updatedAt: updatedAt.valueOf(),
    createdAt: createdAt.valueOf(),
    internalUpdatedAt: internalUpdatedAt.valueOf()
  });
};